/**
 * Zod schemas for KorvoChat component validation
 * 
 * These schemas provide runtime validation for external data (API/database responses)
 * that cannot be trusted at compile time. TypeScript types are erased at runtime,
 * so Zod ensures data integrity in production.
 */

import { z } from 'zod'


/**
 * ChatSession schema matching the ChatSession type
 * 
 * Validates:
 * - id: non-empty string
 * - title: non-empty string
 * - threadId: string or null
 * - createdAt: positive number (timestamp)
 * - updatedAt: positive number (timestamp)
 * - metadata: optional object
 */
export const ChatSessionSchema = z.object({
  id: z.string().min(1, 'Session ID must be a non-empty string'),
  title: z.string().min(1, 'Session title must be a non-empty string'),
  threadId: z.string().nullable(),
  createdAt: z.number().positive('Created timestamp must be a positive number'),
  updatedAt: z.number().positive('Updated timestamp must be a positive number'),
  metadata: z.record(z.string(), z.unknown()).optional(),
})

/**
 * Type inferred from the schema (matches ChatSession type)
 */
export type ChatSessionSchemaType = z.infer<typeof ChatSessionSchema>

